var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#0959d9",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-3",
    "data-name": "Oval",
    fill: "none",
    stroke: "#0959d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "np_sad-emoji_3092162_000000",
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.51,0A14.809,14.809,0,0,0,.129,8.339,1.136,1.136,0,0,0,.668,9.9a1.136,1.136,0,0,0,1.561-.539,12.668,12.668,0,0,1,22.678,0,1.111,1.111,0,0,0,1.02.661,1.771,1.771,0,0,0,.539-.12A1.185,1.185,0,0,0,27,8.341,15.1,15.1,0,0,0,13.509,0Z",
    transform: "translate(16.309 37.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,3.9A3.9,3.9,0,1,1,3.9,7.8,3.891,3.891,0,0,1,0,3.9Z",
    transform: "translate(15.481 16.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,3.9A3.891,3.891,0,0,1,3.9,0,3.932,3.932,0,0,1,7.8,3.9,3.9,3.9,0,1,1,0,3.9Z",
    transform: "translate(36.6 17.039)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSad);
export default __webpack_public_path__ + "static/media/icon-sad.12ff3b8149e1e21c6a96e8576f4c3f7e.svg";
export { ForwardRef as ReactComponent };